var map = {
	"./BlueStarLogo.png": 6432,
	"./Civillaw.jpg": 9565,
	"./DELUX.png": 5922,
	"./Dotsmark.jpg": 4264,
	"./Dotsmark.png": 1798,
	"./GSCaltex.png": 1084,
	"./INENSY.png": 9627,
	"./Infexn.jpg": 6122,
	"./Infexn.png": 2311,
	"./KHUSHI.png": 9331,
	"./KOSCH.jpg": 8848,
	"./LOGO-black.png": 2039,
	"./LOGO.png": 8297,
	"./Maruti.png": 2499,
	"./PRANJAL.jpg": 182,
	"./Plada.jpg": 4757,
	"./Plada.png": 4951,
	"./RINA.png": 9121,
	"./Remson.jpg": 9311,
	"./Remson.png": 8059,
	"./ShriRaj.png": 9223,
	"./Simson.png": 2314,
	"./TALWALKERS.png": 2892,
	"./UCIL.png": 2479,
	"./ads.jpg": 6512,
	"./ads1.jpg": 565,
	"./ads1.png": 7479,
	"./ascent.jpg": 1268,
	"./ascent.png": 6010,
	"./binny-jewels.png": 9750,
	"./blog.png": 9151,
	"./blogbg.png": 5547,
	"./bootique.png": 7190,
	"./clentech.jpg": 3260,
	"./clentech.png": 9486,
	"./client.png": 8033,
	"./corporatelaw.jpg": 3673,
	"./criminallaw.jpg": 7943,
	"./cross.png": 4377,
	"./emosons.png": 3276,
	"./engage.jpeg": 1265,
	"./engage.png": 8006,
	"./eskay-resorts.png": 8510,
	"./facebook.png": 6463,
	"./familylaw.jpeg": 8329,
	"./full-menu.png": 7554,
	"./gmail.png": 8578,
	"./grow.webp": 8705,
	"./harsh.jpg": 4113,
	"./house-of-spice.jpg": 2982,
	"./iccl.jpg": 9513,
	"./iccl.png": 704,
	"./ims.jpg": 4338,
	"./ims.png": 8907,
	"./introbg.png": 7965,
	"./jcb.jpg": 3,
	"./karan.jpg": 9365,
	"./kbc.png": 1038,
	"./ketan.jpg": 2575,
	"./ketanconsultancy.png": 8041,
	"./kr-chauksey.png": 6061,
	"./labourlaw.jpg": 2298,
	"./linkedin.png": 8518,
	"./litigation-service.webp": 9330,
	"./mahyco.png": 490,
	"./main.jpg": 5767,
	"./menu.png": 3325,
	"./muza-hospitality.png": 7631,
	"./nclt.webp": 6468,
	"./nonlitigation-service.jpg": 428,
	"./novo.png": 7903,
	"./pelltech-healthcaer.png": 80,
	"./pharmapoint.jpg": 3641,
	"./pharmapoint.png": 6499,
	"./practice.png": 2732,
	"./practicesub.png": 1554,
	"./pradeep.jpg": 8617,
	"./prapti.jpg": 4863,
	"./raveen.jpg": 3878,
	"./sachin.jpg": 6011,
	"./safetynet.png": 6467,
	"./sambhaji.jpg": 869,
	"./samidha.jpg": 809,
	"./sanjay.jpg": 3761,
	"./search-icon.png": 674,
	"./shubham-tanks.jpg": 4279,
	"./star-union.png": 5115,
	"./team.jpg": 4528,
	"./team.png": 2029,
	"./vaishali.png": 7930,
	"./vipul.jpg": 2384,
	"./vishal.jpg": 7109,
	"./vsipr.png": 2983,
	"./whatsappicon.png": 8469,
	"./yash.jpg": 2349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;